import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-signature',
  templateUrl: './signature.page.html',
  styleUrls: ['./signature.page.scss'],
})
export class SignaturePage implements OnInit {

  signature: string = '';
  finished_loading = false;

  @ViewChild('bodyEditor') bodyEditor: any;
  private lastCursorIndex: number | null = null;
  constructor(private apiService: ApiService, public globalService: GlobalService,private modalController: ModalController) { }

  ngOnInit() {
    this.Get();
  }
  OnEditorSelectionChanged(event: any) {
    if (event.range !== null) {
      this.lastCursorIndex = event.range.index;
    }
  }

  OnEditorContentChanged(event: any) {
    const range = event.editor?.getSelection();
    if (range !== null) {
      this.lastCursorIndex = range?.index ?? this.lastCursorIndex;
    }
  }

  AppendToBody(field: string) {
    const quill = this.bodyEditor?.quillEditor;
    if (quill) {
      const index = this.lastCursorIndex ?? quill.getLength();
      const charBefore = index > 0 ? quill.getText(index - 1, 1) : ' ';
      const charAfter = quill.getText(index, 1);
      const prefix = charBefore !== ' ' ? ' ' : '';
      const suffix = charAfter !== ' ' && charAfter !== '.' && charAfter !== '\n' && charAfter !== '' ? ' ' : '';
      const textToInsert = prefix + field + suffix;
      quill.insertText(index, textToInsert, 'user');
      const newIndex = index + textToInsert.length;
      quill.setSelection(newIndex, 0);
      this.lastCursorIndex = newIndex;
      this.signature = quill.root.innerHTML;
    } else {
      this.signature = (this.signature || '') + field;
    }
  }


  async Get(){
    this.finished_loading = false;
    let data: any = await this.apiService.get('team_members/email/signature');
    if(data.success) this.signature = data.data[0].signature;
    this.finished_loading = true;
  }
  async Update() {
    let post = {
      signature: this.signature
    }
    let data: any = await this.apiService.put('team_members/email/signature',post);
    this.globalService.presentToastMessage(data.message,data.success);
  }

  async Close() {
    this.modalController.dismiss();
  }

}
